@if (showPen && !lukittu) {
  <app-icon-button (click)="toggleEdit()" actionId="Avasi dialogin: Veroilmoitus > Avaa muokkaa kynä" [dynamicClass]="{ 'edit-pen-active': editing }" additionalClass="edit-pen">
    <span class="fa fa-pencil"></span>
  </app-icon-button>
}

@if (editing && !lukittu) {
  <div class="tili-num">{{ numero }}</div>
  <div class="long-col">
    {{ label }}
    @if (help) {
      <span [title]="help" class="ion-ios-help-circle-outline" style="margin-left: 15px; color: darkgray"></span>
    }
  </div>
  <input [formField]="arvo" type="text" (blur)="onBlur()" (input)="onChange()" [allowNegative]="allowNegative" decimalNumberField [showAllDecimals]="true" [numberOfDecimals]="desimaaleja" class="short-col input currency" autocomplete="kirjanasdfpitoaineistoarkki" data-lpignore="true" />
  <div class="end-marking">
    {{ end }}
    @if (saving()) {
      <span class="saving" [@slowInQuickOut]="'in'">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </span>
    }
    @if (saveSuccess()) {
      <span class="save-success-text tallennusilmoituksen-nayttoaika" [@quickInSlowOut]="'in'" (animationend)="piilotaOnnistumisilmoitus()"> Summa tallennettiin </span>
    }
    @if (saveSuccess()) {
      <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle', 'margin-bottom': '6px' }">done</mat-icon>
    }
    @if (saveFailure()) {
      <span class="save-failure-text"> Tallentamisen aikana tapahtui virhe. Ole hyvä ja yritä uudelleen. </span>
    }
    @if (saveFailure()) {
      <mat-icon class="save-failure-icon" [ngStyle]="{ color: 'rgb(255, 72, 102)', 'vertical-align': 'middle' }">error_outline</mat-icon>
    }
  </div>
  @if (naytaEhdotus) {
    <div style="flex-basis: 100%" class="ehdotusnappula-container">
      <app-primary-button (click)="ehdotus()" actionId="Veroilmoitus: hae ehdotus"> Hae ehdotus </app-primary-button>
    </div>
  }
  @if (kenttaVirhe) {
    <div class="kentta-virhe-container">
      @for (virheViesti of kentanVirheViestit; track virheViesti) {
        <div class="kentta-virhe-rivi">
          <mat-icon class="kentta-virhe-ikoni">error_outline</mat-icon>
          <span>{{ virheViesti }}</span>
        </div>
      }
    </div>
  }
} @else {
  <div class="tili-num">{{ numero }}</div>
  <div class="long-col">{{ label }}</div>
  <div app-veroilmoitus-value-read-only [numero]="numero" [veroilmoitus]="veroilmoitus" [repeatingMetadata]="repeatingMetadata" [format]="format" [desimaaleja]="desimaaleja" [log]="log" class="short-col currency"></div>
  <div class="end-marking">{{ end }}</div>
}
